// Default State


export const state = {
    currentId: 0
}





// WEBPACK FOOTER //
// ./src/store/state.js